// import Swiper JS
import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
// import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

// gsap stuff
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// controllers
import Slider from './controllers/sliderclick_controller';
import WindowHeight from './controllers/windowheight_controller';
import Tile from './controllers/tile_controller';
import MediaBlock from "./controllers/mediaBlock";
import GalleryModal from "./controllers/galleryModal";
import Search from "./controllers/search";
import Nav from "./controllers/nav";
import WordWrap from './controllers/wordWrap';
import inView from './controllers/inView';
import parallax from './controllers/parallax';
import Stats from './controllers/stats_controller';
import ChartDoughnut from './controllers/chartDoughnut';
import ChartStat from './controllers/chartStat';
import Profiles from './controllers/profiles_controller';

document.addEventListener("DOMContentLoaded", function() {

  /*----------------*/
  /* Mega Menu */
  /*----------------*/

  // Adjust the position of the MegaMenu
  const adjustMegaMenuPosition = (parent) => {
    const megaMenu = parent.querySelector(".nav-item__container.isMegaMenu");
    if (megaMenu) {
      const megaMenuOffset = megaMenu.getBoundingClientRect();
      megaMenu.style.left = `-${megaMenuOffset.left}px`;
    }
  };

  // Reset styles for all MegaMenus
  const resetMegaMenuStyles = () => {
    document.querySelectorAll(".nav-item__container.isMegaMenu").forEach((menu) => {
      menu.removeAttribute("style");
    });
  };

  // Initialize hover interactions for MegaMenus
  const initializeMegaMenuHover = () => {
    document.querySelectorAll(".nav__item .nav-item__container.isMegaMenu").forEach((menu) => {
      const parent = menu.closest(".nav__item");

      if (!parent) return;

      parent.addEventListener("mouseenter", () => {
        parent.classList.add("hover");
        adjustMegaMenuPosition(parent);
      });

      parent.addEventListener("mouseleave", () => {
        parent.classList.remove("hover");
        resetMegaMenuStyles();
      });
    });
  };

  // Initialize MegaMenu functionality
  initializeMegaMenuHover();

  /*----------------*/
  /* Header search (mobile) */
  /*----------------*/

  // Open the search container
  document.querySelector(".nav .nav__burger_search").addEventListener("click", () => {
    document.querySelector(".nav .nav__search-container").classList.add("open");
  });

  /*----------------*/
  /* Mobile Menu */
  /*----------------*/

  // Toggle the menu and sidebar visibility
  const toggleMenuAndSidebar = () => {
    const burger = document.querySelector(".nav__burger .menu-sidebar_burger");
    const sidebarNav = document.querySelector(".nav .nav__mobile_menu-container .sidebar-navigation");

    if (!burger || !sidebarNav) return;

    burger.addEventListener("click", function () {
      this.parentElement.classList.toggle("activeMenu");
      document.body.classList.toggle("menuOpen");

      sidebarNav.style.display = sidebarNav.style.display === "block" ? "none" : "block";
    });
  };

  // Close sidebar-navigation on resize above 1024px
  const closeSidebarOnResize = () => {
    const sidebarNav = document.querySelector(".nav .nav__mobile_menu-container .sidebar-navigation");

    window.addEventListener("resize", () => {
      if (window.innerWidth > 1024) {
        document.querySelectorAll(".activeMenu").forEach((element) => {
          element.classList.remove("activeMenu");
        });

        document.body.classList.remove("menuOpen");

        if (sidebarNav) {
          sidebarNav.style.display = "none";
        }
      }
    });
  };

  // Handle mobile navigation item clicks
  const handleMobileNavigationClicks = () => {
    document.querySelectorAll(".nav__mobile_menu-container .mobileNav li a").forEach((link) => {
      link.addEventListener("click", (event) => {
        const currentMenu = link.closest("ul");
        const currentListItem = link.parentElement;
        const parentLevel = link.closest("ul").dataset.level || 1;
        const parentMenu = document.querySelector(`.level-${parentLevel}`);
        const subMenu = link.nextElementSibling;

        if (currentListItem.classList.contains("back")) {
          // Handle back button
          currentMenu.classList.remove("active");
          if (parentMenu) parentMenu.classList.remove("hidden");
          event.preventDefault();
          document.querySelector(".nav .nav__item-container").classList.remove("hidden");
        } else if (currentListItem.querySelector("ul")) {
          // Handle expanding submenu
          if (subMenu) subMenu.classList.toggle("active");
          currentMenu.classList.add("hidden");
          event.preventDefault();
          document.querySelector(".nav .nav__item-container").classList.add("hidden");
        }
      });
    });
  };

  // Initialize navigation behavior
  const initializeNavigation = () => {
    toggleMenuAndSidebar();
    closeSidebarOnResize();
    handleMobileNavigationClicks();
  };

  // Initialize the script
  initializeNavigation();

  /*----------------*/
  /* Home Slider */
  /*----------------*/

  // init Swiper:
  const swiper = new Swiper('.swiper', {
    modules: [Pagination, Autoplay],
    spaceBetween: 0,
    autoplay: {
      delay: 5000,
    },
    loop: true,
    speed: 500,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'progressbar',
    },
  });

  // Custom Dot Pagination Trigger
  document.querySelectorAll('.banner_items__dot').forEach((dot, index) => {
    dot.addEventListener('click', () => {
      // Navigate to the slide corresponding to the clicked dot
      swiper.slideTo(index);
    });
  });

  // Optionally, update the active dot class on slide change
  swiper.on('slideChange', function () {
    const activeIndex = swiper.realIndex; // Get the current slide index
    document.querySelectorAll('.banner_items__dot').forEach((dot, index) => {
      if (index === activeIndex) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  });

  /*----------------*/
  /* GSAP - Basic Setup */
  /*----------------*/

  gsap.registerPlugin(ScrollTrigger);

  /*----------------*/
  /* GSAP - Animated Headings */
  /*----------------*/

  /*
  const animatedHeadings = document.querySelectorAll('.reveal-h');

  animatedHeadings.forEach(animatedHeading => {
    let animateUpTimeline = gsap.timeline({
      scrollTrigger:{
        trigger: animatedHeading,
        start: "top+=100 bottom",
        // end: "bottom bottom",
        // markers:true,
        // scrub: true,
        toggleActions: "play none none none",
        once: true
      }
    });

    animateUpTimeline.fromTo(animatedHeading, {y:50, opacity: 0, duration: 0.5}, {y: 0, opacity: 1, duration: 0.5});
  });
  */

  /*----------------*/
  /* GSAP - Parallax Header Banners */
  /*----------------*/

  /*
  Replace with dynamic controller below
  ///
  const parallaxHeaders = document.querySelectorAll('[data-controller="opparallax"]');

  parallaxHeaders.forEach(parallaxHeader => {
    parallaxHeader.classList.add('has-parallax');
    const bg = parallaxHeader.querySelector('.header-image__bg, .header-main__bg');

    let parallaxHeaderTimeline = gsap.timeline({
      scrollTrigger:{
        trigger: parallaxHeader,
        start: "top top",
        end: "bottom top",
        // markers:true,
        scrub: true,
        toggleActions: "play none none reverse",
      }
    });

    parallaxHeaderTimeline.fromTo(bg, {y:0}, {y: 70});
  });
  */

  const parallaxElements = document.querySelectorAll('[data-controller~="opparallax"]');
  const parallaxs = Array.from(parallaxElements).map((element) => new parallax(element));

  /*----------------*/
  /* Window Height */
  /*----------------*/

  const windowHeightElements = document.querySelectorAll('[data-controller~="windowheight"]');
  const windowHeights = Array.from(windowHeightElements).map((element) => new WindowHeight(element));

  /*----------------*/
  /* Profiles */
  /*----------------*/

  const profileElements = document.querySelectorAll('[data-controller~="profiles"]');
  const profiles = Array.from(profileElements).map((element) => new Profiles(element));

  /*----------------*/
  /* Slider */
  /*----------------*/

  /*
  const sliderElement = document.querySelector('.slider');
  if (sliderElement) {
    const slider = new Slider(sliderElement);
  } else {
    console.error('Slider element not found!');
  }
  */

  const slider = new Slider(document.querySelector('.slider'));

  /*
  const swiperSlider = new Swiper('.slider__wrap', {
    modules: [Pagination, Navigation],
    // loop: true,
    // slidesPerView: 1
    // slidesPerView: 1,     // Shows one full slide + part of the next
    // centeredSlides: true,    // Centers the active slide
    spaceBetween: 0,        // Adds space between slides
    loop: true,              // Enables looping
    pagination: {
      el: '.swiper-pagination', // Target the pagination container
      clickable: true,          // Makes pagination bullets clickable
      type: 'progressbar',
    },
  });
  */

  /*----------------*/
  /* Tiles */
  /*----------------*/

  /*
  // temp disabled. However effect seems to heavy i.e. too much movement
  const tileElements = document.querySelectorAll('[data-controller~="tile"]');
  const tiles = Array.from(tileElements).map((element) => new Tile(element));
  */

  /*----------------*/
  /* Journal Elements */
  /*----------------*/

  // Initial setup
  inView();

  /*----------------*/
  /* Media Block */
  /*----------------*/

  // Initialize the MediaBlock on a specific element
  const mediaBlockElements = document.querySelectorAll('.media-block');
  const mediaBlocks = Array.from(mediaBlockElements).map((element) => new MediaBlock(element));

  // Optional: Add global cleanup on page unload for all instances
  window.addEventListener('unload', () => {
    mediaBlocks.forEach(mediaBlock => mediaBlock.disconnect());
  });

  /*----------------*/
  /* Gallery Modal */
  /*----------------*/

  const galleryModalElements = document.querySelectorAll('.gallery');
  const galleryModals = Array.from(galleryModalElements).map((element) => new GalleryModal(element));

  /*----------------*/
  /* Nav */
  /*----------------*/

  const nav = document.querySelector('nav');
  if (nav) {
    new Nav(nav);
  }

  /*----------------*/
  /* Search Input Box */
  /*----------------*/

  const searchElement = document.querySelector('.search');
  if (searchElement) {
    const searchInstance = new Search(searchElement);
  }

  /*----------------*/
  /* Word Wrap */
  /*----------------*/

  const wordWrapElements = document.querySelectorAll('[word-wrap]');
  wordWrapElements.forEach((el) => new WordWrap(el));

  /*----------------*/
  /* Stats */
  /*----------------*/
  const statsElement = document.querySelector('[stats]');
  if (statsElement) {
    const stats = new Stats(statsElement);
  }

  /*----------------*/
  /* Charts */
  /*----------------*/

  // doughnut
  const chartDoughnutsElements = document.querySelectorAll('.chart-donut');
  chartDoughnutsElements.forEach((el) => new ChartDoughnut(el));

  // stats
  const chartStatsElements = document.querySelectorAll('.chart-statistic');
  chartStatsElements.forEach((el) => new ChartStat(el));

});